export default __webpack_public_path__ + "static/media/sports04.9071ece2.png";